import { useState, useEffect } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { HealthcareDomain, Location } from "@/types/core";
import { Company, CompanySize } from "@/types/company";
import { Department, JobRole } from "@/types/jobAttributes";
import { JobSetting, JobSalaryCurrency } from "@/types/jobPost";

// hook to populate the separate filter menu items like DepartmentFilter

// Date Options look like:
// {"label": "Past 24 hours", "value": 1},
// {"label": "Past 3 days", "value": 3},
// {"label": "Past week", "value": 7},
// {"label": "Past month", "value": 30},
export interface DateOption {
  label: string;
  value: number;
}

export interface JobPostFilterOptions {
  companies: Pick<Company, "id" | "company_name">[];
  healthcareDomains: Pick<HealthcareDomain, "id" | "value">[];
  locations: Pick<
    Location,
    | "id"
    | "name"
    | "location_type"
    | "parent_name"
    | "parent_location_type"
    | "is_active"
  >[];
  companySizes: Pick<CompanySize, "id" | "size_range">[];
  departments: Pick<Department, "id" | "dept_name">[];
  jobRoles: Pick<JobRole, "id" | "role_name">[];
  jobSettings: Pick<JobSetting, "id" | "setting_name">[];
  jobSalaryCurrencies: Pick<
    JobSalaryCurrency,
    "id" | "currency_code" | "currency_sign"
  >[];
  dateOptions: DateOption[];
}

export const useJobPostFilterOptions = () => {
  const [filters, setFilters] = useState<JobPostFilterOptions | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axiosInstance.get(
          "jobs/job_posts/filter_options/",
        );

        setFilters(response.data);
      } catch (err: unknown) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchFilters();
  }, []);

  return { filters, loading, error };
};
